import React from "react";
import { Card, CardBody } from "shards-react";

class CardStat extends React.Component
{
    render () {
        return (
            <Card className="cardStat">
                <CardBody className="d-flex px-3">
                    <div className="cardStat__icon">
                  </div>
                    <div>
                        <span className="cardStat__label">
                            {this.props.icon}
                            {this.props.label}
                        </span>
                        <h6 className={"cardStat__value " + this.props.classColor}>{this.props.value}</h6>
                    </div>
                </CardBody>
            </Card>
        );
    }
}

export default CardStat;


// WEBPACK FOOTER //
// ./src/components/stats/CardStat.js